/** Site quota package type. */
export var PackageType;
(function (PackageType) {
    PackageType["UNKNOWN_PACKAGE"] = "UNKNOWN_PACKAGE";
    PackageType["FREE"] = "FREE";
    PackageType["BASIC"] = "BASIC";
    PackageType["GROWTH"] = "GROWTH";
    PackageType["ADVANCED"] = "ADVANCED";
    PackageType["TRIAL"] = "TRIAL";
    PackageType["CUSTOM"] = "CUSTOM";
    PackageType["PRO"] = "PRO";
    PackageType["ELITE"] = "ELITE";
    PackageType["ELITE_PLUS"] = "ELITE_PLUS";
})(PackageType || (PackageType = {}));
/** Quota type. */
export var QuotaType;
(function (QuotaType) {
    QuotaType["UNKNOWN_QUOTA"] = "UNKNOWN_QUOTA";
    QuotaType["CONVERSATIONS"] = "CONVERSATIONS";
    QuotaType["DOCUMENTS"] = "DOCUMENTS";
})(QuotaType || (QuotaType = {}));
export var ProviderName;
(function (ProviderName) {
    ProviderName["UNKNOWN"] = "UNKNOWN";
    ProviderName["SBS"] = "SBS";
    ProviderName["LICENSER"] = "LICENSER";
    ProviderName["BASS"] = "BASS";
    ProviderName["RESELLER"] = "RESELLER";
    ProviderName["RECURRING_INVOICES"] = "RECURRING_INVOICES";
})(ProviderName || (ProviderName = {}));
export var IntervalUnit;
(function (IntervalUnit) {
    /** unknown interval unit */
    IntervalUnit["UNKNOWN"] = "UNKNOWN";
    /** day */
    IntervalUnit["DAY"] = "DAY";
    /** week */
    IntervalUnit["WEEK"] = "WEEK";
    /** month */
    IntervalUnit["MONTH"] = "MONTH";
    /** year */
    IntervalUnit["YEAR"] = "YEAR";
})(IntervalUnit || (IntervalUnit = {}));
export var SubscriptionStatus;
(function (SubscriptionStatus) {
    SubscriptionStatus["UNKNOWN"] = "UNKNOWN";
    SubscriptionStatus["AUTO_RENEW_ON"] = "AUTO_RENEW_ON";
    SubscriptionStatus["AUTO_RENEW_OFF"] = "AUTO_RENEW_OFF";
    SubscriptionStatus["MANUAL_RECURRING"] = "MANUAL_RECURRING";
    SubscriptionStatus["CANCELLED"] = "CANCELLED";
    SubscriptionStatus["TRANSFERRED"] = "TRANSFERRED";
})(SubscriptionStatus || (SubscriptionStatus = {}));
/** Reason for subscription reactivation */
export var ReactivationReasonEnum;
(function (ReactivationReasonEnum) {
    ReactivationReasonEnum["UNKNOWN"] = "UNKNOWN";
    /**
     * Subscription was reactivated due to billing status change from CANCELED to ACTIVE, for example if it was incorrectly
     * canceled because of suspicion of fraud
     */
    ReactivationReasonEnum["BILLING_STATUS_CHANGE"] = "BILLING_STATUS_CHANGE";
    /** Subscription was reactivated after a chargeback dispute */
    ReactivationReasonEnum["REACTIVATED_AFTER_CHARGEBACK"] = "REACTIVATED_AFTER_CHARGEBACK";
})(ReactivationReasonEnum || (ReactivationReasonEnum = {}));
export var Initiator;
(function (Initiator) {
    Initiator["UNKNOWN"] = "UNKNOWN";
    Initiator["USER_REQUESTED"] = "USER_REQUESTED";
    Initiator["APP_MANAGED"] = "APP_MANAGED";
    Initiator["PASSIVE"] = "PASSIVE";
})(Initiator || (Initiator = {}));
export var UnassignReason;
(function (UnassignReason) {
    UnassignReason["UNKNOWN"] = "UNKNOWN";
    UnassignReason["USER_REQUESTED"] = "USER_REQUESTED";
    UnassignReason["REPLACED_BY_ANOTHER_SUBSCRIPTION"] = "REPLACED_BY_ANOTHER_SUBSCRIPTION";
})(UnassignReason || (UnassignReason = {}));
/** Copied from SBS */
export var ContractSwitchType;
(function (ContractSwitchType) {
    ContractSwitchType["NOT_APPLICABLE"] = "NOT_APPLICABLE";
    ContractSwitchType["ADDITIONAL_QUANTITY"] = "ADDITIONAL_QUANTITY";
    ContractSwitchType["CREDIT_UNUSED_PERIOD"] = "CREDIT_UNUSED_PERIOD";
    ContractSwitchType["REFUND_PRICE_DIFF"] = "REFUND_PRICE_DIFF";
    ContractSwitchType["ADJUST_PERIOD_END"] = "ADJUST_PERIOD_END";
    ContractSwitchType["DOWNGRADE_GRACE_PERIOD"] = "DOWNGRADE_GRACE_PERIOD";
    ContractSwitchType["FULL_AMOUNT_PERIOD"] = "FULL_AMOUNT_PERIOD";
    ContractSwitchType["END_OF_PERIOD"] = "END_OF_PERIOD";
    ContractSwitchType["PENDING_CHANGES"] = "PENDING_CHANGES";
    ContractSwitchType["DOWNGRADE_RENEWAL"] = "DOWNGRADE_RENEWAL";
})(ContractSwitchType || (ContractSwitchType = {}));
export var ContractSwitchReason;
(function (ContractSwitchReason) {
    ContractSwitchReason["EXTERNAL_PROVIDER_TRIGGER"] = "EXTERNAL_PROVIDER_TRIGGER";
    ContractSwitchReason["PRICE_INCREASE"] = "PRICE_INCREASE";
})(ContractSwitchReason || (ContractSwitchReason = {}));
/** Reason for Price Increase Trigger */
export var PriceIncreaseTrigger;
(function (PriceIncreaseTrigger) {
    PriceIncreaseTrigger["NEAR_RENEWAL"] = "NEAR_RENEWAL";
    PriceIncreaseTrigger["RECURRING_SUCCESS"] = "RECURRING_SUCCESS";
    PriceIncreaseTrigger["MANUAL"] = "MANUAL";
})(PriceIncreaseTrigger || (PriceIncreaseTrigger = {}));
/** Triggered when a subscription's product is adusted. */
export var ProductAdjustment;
(function (ProductAdjustment) {
    /** flag to show that the ContractSwitchedEvent is not applicable / needed */
    ProductAdjustment["NOT_APPLICABLE"] = "NOT_APPLICABLE";
    /** flag to show that the ContractSwitchedEvent is a Downgrade */
    ProductAdjustment["DOWNGRADE"] = "DOWNGRADE";
})(ProductAdjustment || (ProductAdjustment = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
//# sourceMappingURL=types.impl.js.map